module.exports = __webpack_public_path__ + "static/027-e62f885bfa6c68c5a2ed99d007350a42.png";